import { styled } from '@asicsdigital/oneasics-blocks';

// This validation is from yup v0.32.11. The email validator in the current version is too permissive (allows "help@asics").
// eslint-disable-next-line
export const EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
export const FORM_INPUT_SPACING = 24;

export const Email = styled.div(({ theme }) => ({
  color: theme.colors.textPrimary,
  fontWeight: 'bold',
  textAlign: 'center',
}));

export const FormDisclaimerText = styled.div(({ theme }) => ({
  color: theme.colors.grey[600],
  fontSize: theme.fontSizes.xxSmall,
  lineHeight: '20px',

  a: {
    color: theme.colors.grey[600],
    fontSize: theme.fontSizes.xxSmall,
    span: {
      lineHeight: '20px',
    },
  },
}));

export const StyledFormError = styled.div(({ theme }) => ({
  color: theme.colors.red,
  textAlign: 'center',
}));

export const StyledSuccess = styled.div(({ theme }) => ({
  color: theme.colors.smurfBlue,
  textAlign: 'center',
}));

export const StyledEmail = styled.div(({ theme }) => ({
  background: theme.colors.grey400,
  borderRadius: '9999px',
  color: theme.colors.black,
  fontWeight: theme.fontWeights.medium,
  textAlign: 'center',
}));

export const StyledEmailChangePassword = styled(Email) (({ theme }) => ({
  display: 'inline-block',
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.medium,
  marginBottom: '24px',
  marginRight: '4px',
}));

export const StyledSubtitle = styled.div(({ theme }) => ({
  color: theme.colors.textPrimary,
  fontSize: theme.fontSizes.small,
  textAlign: 'center',
}));

export const ToLoginText = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  fontSize: theme.fontSizes.small,
  justifyContent: 'center',
  marginTop: '7px',
  '& a' : {
    marginLeft: '7px',
    marginRight: '7px',
  },
}));

export const handleFormErrorAnalytics = ({ formErrors, trackEvent }) => {
  Object.keys(formErrors).forEach((field) => {
    if (formErrors[field].type === 'required') {
      trackEvent({ event_type: 'missing-required-field', field });
    } else {
      trackEvent({ event_type: 'invalid-field', field });
    }
  });
};
